import { WidgetBase } from '../../../_common/platform/ts/WidgetBase';
import { CalendarWidget as mainModule } from './main';
import * as $ from 'jquery';
import { init as mainTheme } from '../../../pdc-widget-calendar/src/ts/themes/main';
import * as Config from './config';

declare var require: any;
require('../sass-main/pdc-widget-calendar.sass');
require('../../../_common/libs/dx25/css/dx.common.css');
require('../../../_common/libs/dx25/css/dx.light.css');

export class CalendarWidget extends WidgetBase {
    public static _name: string = Config.name;
    public static group = Config.group;
    public static moduleName: string = Config.moduleName;
    public static icon: string = Config.icon;
    public static namespace: string = Config.namespace;

    public static themeModule = mainTheme;

    public static load() {
        const def = $.Deferred();

        require.ensure(
            ['./main'],
            (require) => {
                var module: typeof mainModule = require('./main');

                def.resolve(module);
            },
            'pdc-widget-calendar'
        );

        return def;
    }

    constructor(
        values: { [fieldName: string]: any },
        locked: { [fieldName: string]: any },
        ignoreValidation?: boolean,
        glob: any = {}
    ) {
        values['themeNodeIdToExpand'] = Config.themeId; //VR: WI80078
        super(values, locked, ignoreValidation, glob);
    }
}

WidgetBase.register(CalendarWidget);

